var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:hidden mb-8"},_vm._l((_vm.categories),function(category){return _c('filter-single',{key:category.slug,attrs:{"category":category}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }